"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileReportOverlay = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var filesActions = require("@caddigital/sok-reducers/lib/actions/files");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var download_1 = require("utils/download");
var ToastActions = require("@caddigital/sok-reducers/lib/actions/toast");
var Types = require("types");
var files_1 = require("@caddigital/sok-reducers/lib/reducers/files");
require("./styles.scss");
var mapStateToProps = function (state) {
    return {
        token: state.auth.current.token,
        isOpen: state.files.fileReport.isOpen,
        currentProject: state.project.currentProject,
        selected: state.files.fileReport.selected,
        currentFolder: state.files.currentFolder,
        data: state.files.data,
        searchOptions: state.files.searchOptions
    };
};
var mapDispatchToProps = function (dispatch) { return ({
    closeOverlay: function () {
        dispatch(filesActions.toggleFileReportModal());
    },
    exportCSV: function (props) {
        return function (token, files) {
            var retVal = dispatch(ToastActions.addNewToast((0, translation_1.getLocalization)('files/toast/exportcsv/exporting-title'), (0, translation_1.getLocalization)('files/toast/exportcsv/exporting-text'), 'NORMAL', [], undefined, 0));
            var filters = {};
            if (props.selected) {
                filters['includeSubFolders'] = (props.searchOptions.searchString.length > 0 ||
                    props.searchOptions.toggleRecents ||
                    props.searchOptions.toggleShowBookmarks).toString();
                filters['hideEmpty'] =
                    props.searchOptions.toggleHideEmptyFolders.toString();
                filters['bookmarked'] =
                    props.searchOptions.toggleShowBookmarks.toString();
                filters['recents'] = props.searchOptions.toggleRecents.toString();
                filters['search'] =
                    props.searchOptions.searchFileType.isSome() ||
                        props.searchOptions.searchString.length > 0;
                if (props.searchOptions.searchFileType.isSome()) {
                    filters['type'] = props.searchOptions.searchFileType.value;
                }
                if (props.searchOptions.searchString) {
                    filters['name'] = props.searchOptions.searchString;
                }
            }
            else {
                filters['includeSubFolders'] = 'true';
            }
            var uuid = retVal.payload.uuid;
            (0, download_1.exportCSVFromFiles)(token, files, [], filters, undefined, function () {
                return dispatch(ToastActions.removeToast(uuid));
            });
        };
    },
    toggleSelection: function () { return dispatch(filesActions.toggleFileReportSelection()); }
}); };
var statePropsExtractable = Types.extractReturnType(mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(mapDispatchToProps);
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('FileReportOverlay'), (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps), (0, recompose_1.lifecycle)({
    shouldComponentUpdate: function (nextProps) {
        if (this.props.isOpen || nextProps.isOpen) {
            return true;
        }
        return false;
    }
}), recompose_1.pure);
exports.FileReportOverlay = enhance(function (props) { return (React.createElement(sok_ui_1.Overlay, { isOpen: props.isOpen, onClose: function () { return props.closeOverlay(); }, className: 'file-report-content' },
    React.createElement(sok_ui_1.SideMenu, { className: 'sok-folder-shortcut-details', isOpen: props.isOpen, docked: false, orientation: 'right' },
        React.createElement(sok_ui_1.Header, { onClose: function () { return props.closeOverlay(); } }, (0, translation_1.getLocalization)('fileReport/header')),
        React.createElement(sok_ui_1.Container, null,
            React.createElement("div", null,
                React.createElement("span", { className: 'file-report-row' }, (0, translation_1.getLocalization)('fileReport/description')),
                React.createElement("div", { className: 'file-report-row' },
                    React.createElement(sok_ui_1.Input, { type: 'radio', name: 'selected', label: (0, translation_1.getLocalization)('fileReport/fileReportButton'), value: !props.selected, onClick: props.toggleSelection })),
                React.createElement("div", { className: 'file-report-row' },
                    React.createElement(sok_ui_1.Input, { type: 'radio', name: 'selected', label: (0, translation_1.getLocalization)('fileReport/fileReportSelectedViewButton'), value: props.selected, onClick: props.toggleSelection })),
                React.createElement("div", { className: 'file-report-row' },
                    React.createElement(sok_ui_1.Button, { color: 'green', size: 'medium', text: (0, translation_1.getLocalization)('fileReport/createReport'), onClick: function () {
                            if (props.currentFolder) {
                                props.exportCSV(props)(props.token, JSON.stringify(props.searchOptions) ===
                                    JSON.stringify(files_1.defaultFileSearchOptions)
                                    ? [props.currentFolder]
                                    : props.data.files);
                            }
                        } })))),
        React.createElement(sok_ui_1.Footer, null,
            React.createElement(sok_ui_1.Button, { color: "blue", onClick: function () { return props.closeOverlay(); }, text: (0, translation_1.getLocalization)('fileReport/hide') }))))); });
